import { Component, SecurityContext, NgZone, AfterViewInit } from '@angular/core';
import { GlobalConstants } from '../../global-constants';
import { QueryService } from '../../comun/services/query.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { jwtDecode, JwtPayload } from "jwt-decode";
import { BehaviorSubject } from 'rxjs';
import { LoaderService } from '../../comun/services/loader.service';
import { DeviceInfoService } from '../../comun/services/device-info.service';
import Swal from 'sweetalert2';
declare const google: any;

export interface GoogleUser {
  sub: string;            // ID único del usuario en Google
  email: string;
  email_verified: boolean;
  name: string;
  picture: string;
  given_name: string;
  family_name: string;
  iat: number;
  exp: number;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements AfterViewInit {
  global: any = GlobalConstants;
  misdatos: any = {};
  busy = false;
  error: string = '';
  form: FormGroup;
  //siteKey: string = GlobalConstants.siteKey;
  fotos: number = 0;
  private userSubject = new BehaviorSubject<any>(null);
  showPassword: boolean = false;
  remember: boolean = false;

  constructor(private query: QueryService,
              private fb: FormBuilder,
              private sanitizer: DomSanitizer,
              private ngZone: NgZone,
              private loader: LoaderService,
              private deviceInfo: DeviceInfoService) 
  {
    this.form = this.fb.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      nombre: [''],
      picture: [''],
      google_sub: [''],
      //recaptcha: ['', Validators.required]
      deviceInfo: this.deviceInfo.getDeviceInfo()
    });
  }

  //randomInteger = Math.floor(Math.random() * 3) + 1;
  //backgroundImage = GlobalConstants.urlServer + '/img/usracceso' + this.randomInteger + '.jpg';
  backgroundImage = GlobalConstants.urlServer + '/img/perro-portatil.png';

  ngAfterViewInit(): void {
    const interval = setInterval(() => {
      if (typeof google !== 'undefined') {
        clearInterval(interval);

        google.accounts.id.initialize({
          client_id: '934921995714-9r5vnan638c8d3s495mfnebq5pgrl5e6.apps.googleusercontent.com',
          callback: (response: any) => this.handleCredentialResponse(response)
        });

        google.accounts.id.renderButton(
          document.getElementById("google-btn"),
          { theme: "outline", size: "large" }  // opciones de estilo
        );

        // Lanza el One Tap automático
        google.accounts.id.prompt((notification: any) => {
          /*if (notification.isDisplayed()) {
            console.log('One Tap mostrado automáticamente ✅');
          } else if (notification.isNotDisplayed()) {
            console.log('One Tap no se mostró (usuario sin sesión de Google)');
          } else if (notification.isSkippedMoment()) {
            console.log('Usuario rechazó o cerró el popup');
          }*/
        });

      }
    }, 100);
  }

  handleCredentialResponse(response: any) {
    this.ngZone.run(() => {
      // Aquí recibes el JWT de Google
      const token = response.credential;
      // Guardar el token en localStorage
      localStorage.setItem('google_token', token);

      const user: GoogleUser = jwtDecode<GoogleUser>(token);
      this.ngZone.run(() => {
        this.userSubject.next(user);
        // 🔹 Guardar en localStorage para compartir entre proyectos
        localStorage.setItem('googleUser', JSON.stringify(user));
      });

      //this.userData = user;
      this.form.patchValue({
        nombre: user.name,
        picture: user.picture,
        username: user.email,
        google_sub: user.sub
      });
      this.login();
    });
  }

  sanitizar() {
    // Sanitizamos los valores de los campos antes de enviarlos al servidor
    this.form.value.username = this.sanitizer.sanitize(SecurityContext.HTML, this.form.value.username) || '';
    this.form.value.password = this.sanitizer.sanitize(SecurityContext.HTML, this.form.value.password) || '';
  }

  acceso() {
    this.sanitizar();
    this.error = '';
    this.form.markAllAsTouched();

    if (this.form.valid) {
      this.busy = true;
      //const formData = this.form.value;
      // Envía el token al backend 
      //this.query.verificaCaptcha(formData.recaptcha).subscribe((resultado:any) => {
      //  if (resultado.success) {
          // Backend login
          this.login();
        /*} else {
          this.error = resultado.message;
        }
      });*/
    } else {
      this.busy = false;
      this.error = 'Por favor, revisa los campos indicados antes de continuar.';
    }
  }

  login() {
    if (this.busy === false) {
      this.busy = true;
    }
    this.error = '';
    this.loader.show();
    const formData = this.form.value;
    const google_sub = formData.google_sub || '';    
    this.query.query('login', null, formData).subscribe((resultado:any) => {
      //this.busy = false;
      // Error
      if (resultado['resultado'] == 'ERROR') {
        this.error = resultado.mensaje;
        this.form.get('password')?.setValue('');
        this.busy = false;
        //formData.recaptcha = '';
        //this.resetCaptcha();
        this.loader.hide();
      // usuario bloqueado
      } else if (resultado['resultado'] == 'BLOCKED') {
        this.form.get('password')?.setValue('');
        this.error = resultado.mensaje;
        this.error += ' <a href="' + GlobalConstants.urlServer + '/password-remember" class="active-href">¿No recuerdas la constraseña?</a>';
        this.busy = false;
        this.loader.hide();
      // OK
      } else {
        const token = resultado.token;
        localStorage.setItem('token', token); // Guardar el token en el almacenamiento local
        this.form.get('username')?.setValue('');
        this.form.get('password')?.setValue('');
        this.query.query('misdatos', 'GET', { ID: 0 }).subscribe((resultado:any) => {
          const slug = resultado.slug;
          if (resultado.cuenta_desactivada == 'X') {
            this.error = 'Cuenta desactivada temporalmente.';            
            this.busy = false;
            this.loader.hide();
            Swal.fire({
              title: 'Confirmación',
              text: '¿Quieres volver a activar tu cuenta?',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Sí',
              cancelButtonText: 'Cancelar',
              customClass: {
                confirmButton: 'custom-swal-confirm',
                /*cancelButton: 'custom-swal-cancel'*/
              },
            }).then((result) => {
              if (result.isConfirmed) {
                this.query.query('misdatos', 'ACTIVAR', null).subscribe((resultado:any) => {
                  localStorage.setItem('token', token); // Guardar el token en el almacenamiento local
                  window.location.href = GlobalConstants.urlServer + 'perfil/' + slug;
                });
              } else {
                this.query.query('misdatos', 'LOGOUT', null).subscribe((resultado:any) => {
                  localStorage.removeItem('token'); // Eliminar token si la cuenta está desactivada
                });
              }
            });
            return;
          } else {
            window.location.href = GlobalConstants.urlServer + 'perfil/' + slug;
            //this.loader.hide();
          }
        });
      }
    });
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  /*resetCaptcha(): void {
    if (this.captchaRef) {
      this.captchaRef.resetCaptcha(); // Resetea el CAPTCHA correctamente
      this.form.get('recaptcha')?.reset(); // Opcional: reinicia el control del formulario
    }
  }*/

  rememberPassword() {
    this.error = '';
    this.remember = true;
  }

}
